/**
 * @flow
 * @relayHash 1e9f86c2541100df73e2f39dbb93e270
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SupplierCategoryUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdateSupplierCategoryMutationVariables = {|
  data: SupplierCategoryUpdateInput
|};
export type UpdateSupplierCategoryMutationResponse = {|
  +updateSupplierCategory: {|
    +id: string
  |}
|};
export type UpdateSupplierCategoryMutation = {|
  variables: UpdateSupplierCategoryMutationVariables,
  response: UpdateSupplierCategoryMutationResponse,
|};
*/


/*
mutation UpdateSupplierCategoryMutation(
  $data: SupplierCategoryUpdateInput!
) {
  updateSupplierCategory(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "SupplierCategoryUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateSupplierCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "SupplierCategoryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateSupplierCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateSupplierCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateSupplierCategoryMutation",
    "id": null,
    "text": "mutation UpdateSupplierCategoryMutation(\n  $data: SupplierCategoryUpdateInput!\n) {\n  updateSupplierCategory(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '550e9e0fc3824ceafa2c2d85f3ad531b';
module.exports = node;
